import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";

import toast from "react-hot-toast";
import { AuthContext } from "../../../context/Authcontext";
import api from "../../../utils/api";

const base_url = process.env.REACT_APP_API_URL;

const BetHistory = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [history, setHistory] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [totals, setTotals] = useState({ stake: 0, profit: 0 });
  const [showModal, setShowModal] = useState(false);
  const [toDelete, setToDelete] = useState({
    eventId: null,
    phone: null,
    selectionId: null,
  });
  const [remark, setRemark] = useState("");
  const { getRoles } = useContext(AuthContext);
  const [permit, setPermit] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(
    !(window.innerWidth < 768)
  );

  const [filter, setFilter] = useState({
    result: "",
    phone: "",
    eventName: "",
    minBet: "",
    maxBet: "",
    dateFrom: "",
    dateTo: "",
  });

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const fethcHistory = async () => {
    try {
      const auth = localStorage.getItem("admin");
      const response = await api.get("/api/webapi/betHistory", {
        headers: {
          Accept: "application/json",
          Authorization: `${auth}`,
        },
      });

      if (response?.data.success) {
        setHistory(response.data.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const applyFilters = () => {
    let result = [...history];

    const statusMap = {
      win: 1,
      loss: 2,
      cashout: 10,
      pending: 0,
    };

    if (filter.result) {
      result = result.filter(
        (item) => item.status === statusMap[filter.result]
      );
    }

    if (filter.phone) {
      result = result.filter((item) => item.phone.toLowerCase().includes(filter.phone));
    }

    if (filter.eventName) {
      result = result.filter((item) =>
        item.eventName.toLowerCase().includes(filter.eventName.toLowerCase())
      );
    }

    if (filter.minBet) {
      result = result.filter(
        (item) => parseFloat(item.betAmount) >= parseFloat(filter.minBet)
      );
    }

    if (filter.maxBet) {
      result = result.filter(
        (item) => parseFloat(item.betAmount) <= parseFloat(filter.maxBet)
      );
    }

    if (filter.dateFrom && filter.dateTo) {
      result = result.filter((item) => {
        const itemDate = new Date(item.date);
        return (
          itemDate >= new Date(filter.dateFrom) &&
          itemDate <= new Date(filter.dateTo)
        );
      });
    }

    setFilteredData(result);

    const totalStake = result.reduce(
      (acc, item) => acc + parseFloat(item.betAmount || 0),
      0
    );
    const totalProfit = result.reduce(
      (acc, item) =>
        acc +
        parseFloat(
          item.status === 10 ? item.cashoutAmount || 0 : item.profit || 0
        ),
      0
    );

    setTotals({ stake: totalStake, profit: totalProfit });
  };

  const fetchRoles = useCallback(async () => {
    const auth = localStorage.getItem("admin");
    const role = localStorage.getItem("role");

    try {
      const roles = await getRoles(auth, role);
      let allPermit = [];

      const vall = Object.values(roles[0]);
      const arr = Object.values(vall[0]);

      arr.map((role) => {
        const permis = Object.values(role);

        permis.map((per) => {
          const k = Object.values(per);

          k.map((real) => {
            allPermit.push(real);
          });
        });
      });

      setPermit(allPermit);
    } catch (error) {
      console.log("ert", error);
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    fethcHistory();
    fetchRoles();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [history, filter]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setIsSidebarOpen(true);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const openModal = (eventId, phone, selectionId, status,id) => {
    if (status !== 0) {
      toast.error("bet is already settled");
      return;
    }
    setToDelete({ eventId, phone, selectionId,id });
    setShowModal(true);
  };

  const confirmDelete = async () => {
    try {
      const auth = localStorage.getItem("admin");
      const response = await api.post(
        "/api/webapi/deleteBet",
        { data: toDelete, remark },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );

      if (response?.data.success) {
        toast.success(response?.data.message);
        setShowModal(false);
        fethcHistory();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 1:
        return "badge bg-success";
      case 2:
        return "badge bg-danger";
      case 10:
        return "badge bg-info";
      case 0:
        return "badge bg-warning text-dark";
      default:
        return "badge bg-secondary";
    }
  };

  return (
    <div className="wrapper">
   
      <div
        className={`content-wrapper d-flex flex-column ${
          !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
        }`}
        style={{
          marginLeft: !isMobile && isSidebarOpen ? "" : "0",
          transition: "margin-left 0.3s ease",
        }}
      >
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6  d-flex justify-content-between">
                <div>
                  <h1>My Bets</h1>
                </div>
                {/* <div>
                  <button
                    className="btn-success rounded-2 "
                    style={{ height: "40px" }}
                    onClick={() => navigate("/admin/liveBets")}
                  >
                    Live Bets
                  </button>
                </div> */}
              </div>
            </div>
          </div>
        </section>

        <div className="container-fluid">
          <div className="card p-3">
            <div className="row g-2 m-1">
              <input
                className="form-control col border-1 rounded-2"
                style={{ marginRight: "8px" }}
                placeholder="Enter Username"
                onChange={(e) =>
                  setFilter({ ...filter, phone: e.target.value })
                }
              />
              {/* <input
                className="form-control col border-1 rounded-2"
                style={{ marginRight: "8px" }}
                placeholder="Event Name"
                onChange={(e) =>
                  setFilter({ ...filter, eventName: e.target.value })
                }
              /> */}
              {/* <input
                className="form-control col border-1 rounded-2"
                style={{ marginRight: "8px" }}
                type="number"
                placeholder="Min Bet"
                onChange={(e) =>
                  setFilter({ ...filter, minBet: e.target.value })
                }
              />
              <input
                className="form-control col border-1 rounded-2"
                style={{ marginRight: "8px" }}
                type="number"
                placeholder="Max Bet"
                onChange={(e) =>
                  setFilter({ ...filter, maxBet: e.target.value })
                }
              /> */}
              <input
                className="form-control col border-1 rounded-2"
                style={{ marginRight: "8px" }}
                type="date"
                onChange={(e) =>
                  setFilter({ ...filter, dateFrom: e.target.value })
                }
              />
              <input
                className="form-control col border-1 rounded-2"
                type="date"
                onChange={(e) =>
                  setFilter({ ...filter, dateTo: e.target.value })
                }
              />
            </div>

            <div className="btn-group mb-3 flex-wrap gap-2">
              {["All", "win", "loss", "pending", "cashout"].map((type) => {
                const colorMap = {
                  All: "primary",
                  win: "success",
                  loss: "danger",
                  pending: "warning",
                  cashout: "info",
                };
                const btnColor = colorMap[type];
                const isActive = filter.result === (type === "All" ? "" : type);

                return (
                  <button
                    key={type}
                    className={`btn btn-${
                      isActive ? `btnColor` : `outline-${btnColor}`
                    }`}
                    onClick={() =>
                      setFilter({
                        ...filter,
                        result: type === "All" ? "" : type,
                      })
                    }
                  >
                    {type.charAt(0).toUpperCase() + type.slice(1)}
                  </button>
                );
              })}
            </div>

            <div className="mb-3">
              <strong>Total Bet Amount:</strong> ₹{totals.stake.toFixed(2)}
              <br />
              <strong>
                Total {filter.result === "cashout" ? "Cashout" : "Profit"}:
              </strong>{" "}
              ₹{totals.profit.toFixed(2)}
            </div>

            <div className="table-responsive">
              <table className="table table-hover table-bordered">
                <thead className="thead-dark">
                  <tr>
                    <th>User ID</th>
                    <th>Tournament</th>
                    <th>Match</th>
                    <th>Side</th>
                    <th>Odds</th>
                    <th>Stake</th>
                    <th>Balance</th>
                    <th>P/L</th>
                    <th>Result</th>
                    <th>Status</th>
                    <th>IP</th>
                    <th>Date</th>
                    <th
                      className={permit.includes("Bet Delete") ? "" : "d-none"}
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((data, index) => (
                    <tr key={index}>
                      <td className="border">{data.phone}</td>
                      <td className="border">{data.competitionName}</td>
                      <td className="border">{data.eventName}</td>
                      <td className="border">
                        <span
                          className="rounded p-1 text-white"
                          style={{
                            backgroundColor:
                              data.side === "Back" ? "#4e73df" : "#e74a3b",
                          }}
                        >
                          {data.side}
                        </span>
                      </td>
                      <td className="border">{data.betprice}</td>
                      <td className="border">{data.deducted_amount}</td>
                      <td className="border">{data.balance}</td>
                      <td className="border">
                        {data.profit}
                      </td>
                      <td className="border">
                        {(() => {
                          const status = data.status;
                          const runner = data.runnerName?.toLowerCase();
                          const [team1, team2] = data.eventName?.split(" v ") || [];

                          if (status === 0) return '';                     // match not finished
                          if (status === 1) return data.runnerName;        // you won, show your team
                          if (status === 2) {                              // you lost
                            if (runner === team1?.toLowerCase()) return team2;
                            if (runner === team2?.toLowerCase()) return team1;
                          }
                          return '';
                        })()}
                      </td>

                      <td className="border">
                        <span className={getStatusBadge(data.status)}>
                          {data.status === 1
                            ? "Win"
                            : data.status === 2
                            ? "Loss"
                            : data.status === 10
                            ? "Cashout"
                            : "Pending"}
                        </span>
                      </td>
                      <td className="border">{data.ipAddress}</td>
                      <td className="border">{data.date}</td>
                      <td
                        className={
                          permit.includes("Bet Delete")
                            ? "border"
                            : "d-none border "
                        }
                      >
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() =>
                            openModal(
                              data.eventId,
                              data.phone,
                              data.selectionId,
                              data.status,
                              data.id
                            )
                          }
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {showModal && (
          <div
            className="modal show"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-sm modal-dialog-centered">
              <div className="modal-content p-3">
                <div className="modal-header">
                  <h5 className="modal-title">Confirm Delete</h5>
                  <button
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <p>Are you sure you want to delete:</p>
                  <p>
                    <strong>Event ID:</strong> {toDelete.eventId}
                  </p>
                  <p>
                    <strong>Phone:</strong> {toDelete.phone}
                  </p>
                  <p>
                    <strong>Selection ID:</strong> {toDelete.selectionId}
                  </p>
                  <textarea
                    className="form-control"
                    placeholder="Enter remark"
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                  />
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>
                  <button className="btn btn-danger" onClick={confirmDelete}>
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BetHistory;